<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnCostsSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Kosten van grond- en hulpstoffen en inkoopprijs van de verkopen')"
                         :calculated-value="data.calculated.statement_costs_goods"
                         v-model="data.edit.statement_costs_goods"/>

      <TaxReturnTableRow :description="$gettext('Kosten van uitbesteed werk en andere externe kosten')"
                         :calculated-value="data.calculated.statement_costs_services"
                         v-model="data.edit.statement_costs_services"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>